import type { IdeaCardParserContext } from '@/lib/idea-card-parser-phases';

const isMarkdownTableLine = (line: string): boolean => {
  const trimmed = line.trim();

  if (trimmed.startsWith('|') || trimmed.endsWith('|')) return true;
  if (/^\s*\|[\s\-:]+\|\s*$/.test(trimmed)) return true;
  return false;
};

export const createIdeaCardParserContext = (text: string): IdeaCardParserContext => {
  const lines = text.split(/\r?\n/);
  const isPartOfTable: boolean[] = lines.map(isMarkdownTableLine);

  for (let index = 0; index < lines.length; index++) {
    if (!isPartOfTable[index]) continue;

    if (index > 0 && !isPartOfTable[index - 1] && lines[index - 1].trim().length > 0) {
      if (isMarkdownTableLine(lines[index - 1])) isPartOfTable[index - 1] = true;
    }

    if (index < lines.length - 1 && !isPartOfTable[index + 1] && lines[index + 1].trim().length > 0) {
      if (isMarkdownTableLine(lines[index + 1])) isPartOfTable[index + 1] = true;
    }
  }

  return {
    text,
    lines,
    isPartOfTable,
  };
};
